require('../../modules/es7.string.pad-start');
module.exports = require('../../modules/_core').String.padStart;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/string/pad-start.js
// module id = 229
// module chunks = 0